import React from 'react';
import { HashLink } from 'react-router-hash-link';

const NavLinks = () => {
    return (
        <>
            <HashLink className="px-4 font-extrabold text-gray-500 hover:text-orange-600" smooth to="/#about">
                About
            </HashLink>
            <HashLink className="px-4 font-extrabold text-gray-500 hover:text-orange-600" smooth to="/#features">
                Features
            </HashLink>
            <HashLink className="px-4 font-extrabold text-gray-500 hover:text-orange-600" smooth to="/#portfolio">
                Download
            </HashLink>
            <HashLink className="px-4 font-extrabold text-gray-500 hover:text-orange-600" to="/contact#contact">
                Contact
            </HashLink>
            <HashLink className="text-white bg-orange-600 hover:bg-orange-500 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl" to="/contact#contact">
                Join Rally
            </HashLink>
        </>
    )
}

export default NavLinks;
